import { ImageListItem, Modal } from '@mui/material';
import React from 'react';
import Carousel from 'react-bootstrap/esm/Carousel';
import NextIcon from '../../../assets/Posts/NextIcon';
import { normalizeHeight } from '../../../utils/normalize';
import { PrevButton } from '../../Stories/StoriesModal/styles';
import SnipzInformation from '../SnipzInformation';
import SnipzPlayer from '../SnipzPlayer';
import { CarouselImage, ImageNumber, PostHeader, SnipzModalContainer } from './styles';

type PostModalProps = {
  modal: boolean;
  handleClose: () => void;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  medias: {
    name: string;
    size: string;
    type: string;
    url: string;
  }[];
  type: string;
  authorUsername: string;
  authorAvatarUrl: string;
  createdAt: string;
  description: string[];
  feedType: string;
  tags: string[];
  likes: number;
  comments: number;
  isLiked: boolean;
  likesCount: number;
  setLikesCount: React.Dispatch<React.SetStateAction<number>>;
  commentsCount: number;
  setCommentsCount: React.Dispatch<React.SetStateAction<number>>;
  selectedImage: number;
  modalSelectedImage: number;
  setModalSelectedImage: React.Dispatch<React.SetStateAction<number>>;
  isLikedState: boolean;
  setIsLikedState: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function PostModal({
  modal,
  handleClose,
  setModal,
  id,
  medias,
  type,
  authorUsername,
  authorAvatarUrl,
  createdAt,
  description,
  feedType,
  tags,
  likes,
  comments,
  isLiked,
  likesCount,
  setLikesCount,
  commentsCount,
  setCommentsCount,
  selectedImage,
  modalSelectedImage,
  setModalSelectedImage,
  isLikedState,
  setIsLikedState,
}: PostModalProps) {
  return (
    <Modal
      open={modal}
      onClose={handleClose}
      disableEnforceFocus
    >
      <ImageListItem
        key={id}
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: normalizeHeight(845),
          width: 'fit-content',
          display: 'flex',
          flexDirection: 'row',
          backgroundColor: '#FFF',
          borderRadius: 8,
          outline: 'none',
        }}
      >
        <PostHeader>
          {medias.length > 1 ? (
            <ImageNumber>{modal ? modalSelectedImage + 1 : selectedImage + 1}/{medias.length}</ImageNumber>
          ) : <div />}
        </PostHeader>
        {type === 'snipz' ? (
          <SnipzModalContainer>
            <SnipzPlayer modal={true} isFeed={true} local={false} src={medias[0].url} />
          </SnipzModalContainer>
        ) : (
          <Carousel
            activeIndex={modalSelectedImage}
            defaultActiveIndex={0}
            prevIcon={<PrevButton />}
            nextIcon={<NextIcon />}
            wrap={false}
            interval={null}
            slide={true}
            indicators={false}
            onSelect={(index, e) => setModalSelectedImage(index)}
            style={{
              backgroundColor: 'black',
              objectFit: 'cover',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              maxWidth: 400,
              overflow: 'hidden',
            }}
          >
            {medias.map((image, index) => (
              <Carousel.Item key={index} >
                <CarouselImage
                  src={`${image.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
                  loading="eager"
                  onClick={() => setModal(!modal)}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        )}
        <SnipzInformation
          publicationId={id}
          selectedImage={modalSelectedImage}
          authorUsername={authorUsername}
          authorAvatarUrl={authorAvatarUrl}
          timeSince={createdAt}
          descriptions={description}
          feedType={feedType}
          tags={tags}
          likes={likes}
          comments={comments}
          liked={isLikedState}
          setLiked={setIsLikedState}
          likesCount={likesCount}
          setLikesCount={setLikesCount}
          commentsCount={commentsCount}
          setCommentsCount={setCommentsCount}
        />
      </ImageListItem>
    </Modal>
  );
}